const makeTitleCase = (str: string, del?: RegExp): string => {
  let upper = true;
  let newStr = '';
  for (let i = 0, l = str.length; i < l; i++) {
    if (str[i] === ' ' || (del && str[i].match(del))) {
      upper = true;
      newStr += ' ';
      continue;
    }
    newStr += upper ? str[i].toUpperCase() : str[i].toLowerCase();
    upper = false;
  }
  return newStr;
};

export default makeTitleCase;
